import { useCallback } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { fetchSemaphoreDashboard } from 'features/views/semaphore/actions';

import HalfDoughnutGraph from './HalfDoughnutGraph';
import ImpendingStateTable from './ImpendingStateTable';

export const SemaphoreInfoGraphics = () => {
	const dispatch = useDispatch();

	const handleReload = useCallback(() => {
		dispatch(fetchSemaphoreDashboard());
	}, [dispatch]);

	return (
		<Stack sx={{ height: '380px' }}>
			<Paper sx={{ p: 2, borderRadius: 2, backgroundColor: (theme) => theme.palette.background[100] }}>
				<ComponentLoader fetchStorePath={fetch.constants.urls.semaphoreDashboard} onReload={handleReload}>
					<Grid container>
						<Grid size={12}>
							<Grid container columnSpacing={10}>
								<Grid size={6}>
									<HalfDoughnutGraph />
								</Grid>
								<Grid size={6}>
									<ImpendingStateTable />
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</ComponentLoader>
			</Paper>
		</Stack>
	);
};

export default SemaphoreInfoGraphics;
